
<div class="modal-overlay">
    <div class="card mx-auto border-0">
        <div class="card-header bergh-bg-primary text-white h5">
            Report Breach
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <span class="size">Weet u zeker dat u dit item als doorbroken wilt melden?</span>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white d-flex justify-content-end">
            <button class="btn btn-success mr-2 col-4" (click)="reportBreach()"
            id="btn_move">Ja</button>
        <button class="btn btn-danger mr-2" (click)="cancel.emit(false)" id="btn-cancel">Annuleer</button>
        </div>
    </div>
</div>
